import type React from "react"
import { Helmet } from "react-helmet-async"

interface SEOHeadProps {
  title?: string
  description?: string
  keywords?: string
  image?: string
  url?: string
  type?: string
  structuredData?: object
}

const SEOHead: React.FC<SEOHeadProps> = ({
  title = "Anmol Furniture Bazaar - Premium Furniture Store",
  description = "Discover premium furniture at Anmol Furniture Bazaar. Shop beds, sofas, dining sets, wardrobes & more. Free delivery, 3-year warranty, easy returns.",
  keywords = "furniture, home furniture, beds, sofas, dining table, wardrobe, chairs, tables, premium furniture",
  image = "/og-image.jpg",
  url = "https://anmolfurniture.com",
  type = "website",
  structuredData,
}) => {
  const fullTitle = title.includes("Anmol Furniture") ? title : `${title} | Anmol Furniture Bazaar`

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />

      {/* Twitter */}
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />

      {/* Canonical URL */}
      <link rel="canonical" href={url} />

      {/* Structured Data */}
      {structuredData && <script type="application/ld+json">{JSON.stringify(structuredData)}</script>}
    </Helmet>
  )
}

export default SEOHead
